import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useRef} from 'react';
import {useDialog} from 'react-aria';
import {createPortal} from 'react-dom';

import {useNavbarBottom} from '../../util/hooks/useNavbarBottom';
import {WBAgentChatHistorySidebar} from './chatHistory/WBAgentChatHistorySidebar';
import {useDrawerResize} from './useDrawerResize';
import {useNightModeRevertFilter} from './useNightModeRevertFilter';
import {useWBAgentContextStore} from './WBAgentContextStore';
import {WBAgentHeader} from './WBAgentHeader';
import {WBAgentThread} from './WBAgentThread';

export const WBAgentChatDrawer = () => {
  const ref = useRef<HTMLDivElement>(null);
  const {dialogProps} = useDialog({'aria-label': 'W&B Agent sidebar'}, ref);
  const navbarBottom = useNavbarBottom();
  const {width: drawerWidth, onMouseDown: onDrawerResizeMouseDown} =
    useDrawerResize();
  const nightModeRevertFilter = useNightModeRevertFilter();
  const historySidebarOpen = useWBAgentContextStore(s => s.historySidebarOpen);

  return createPortal(
    <Tailwind className="[font-family:var(--default-font-family)]">
      <div
        ref={ref}
        {...dialogProps}
        className="fixed top-0 right-0 bottom-0 z-[1000] flex flex-col min-h-0 overscroll-none"
        style={{width: drawerWidth, paddingTop: navbarBottom}}>
        <div
          onMouseDown={onDrawerResizeMouseDown}
          className="absolute left-0 top-0 bottom-0 w-[5px] cursor-col-resize z-10"
        />
        <div
          className="absolute inset-0 border-l border-moon-250 bg-white dark:bg-moon-850 dark:border-[#363C44] shadow-[0_12px_24px_0_rgba(13,15,18,0.16)] dark:shadow-[0_12px_24px_0_rgba(13,15,18,0.32)]"
          style={{filter: nightModeRevertFilter}}
        />
        <div className="relative flex flex-col flex-1 min-h-0 overflow-hidden pl-px">
          <WBAgentHeader />
          <div className="flex flex-row flex-1 min-h-0">
            {historySidebarOpen && <WBAgentChatHistorySidebar />}
            <div className="flex flex-col flex-1 min-w-0">
              <WBAgentThread />
            </div>
          </div>
        </div>
      </div>
    </Tailwind>,
    document.body
  );
};
